module.exports = __webpack_public_path__ + "static/herologo-dk-d54e3a56fd6dfa3a1e76ad1c2bc44a2c.svg";